import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="bg-purple-500 p-4 text-white">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-xl font-bold">Building Planning, consultancy and construction</h1>
        <ul className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 mt-2 sm:mt-0">
          <li><Link to="/" className="hover:text-gray-300">Home</Link></li>
          <li><Link to="/services" className="hover:text-gray-300">Services</Link></li>
          <li><Link to="/Gallery" className="hover:text-gray-300">Gallery</Link></li>
          <li><Link to="/portfolio" className="hover:text-gray-300">Portfolio</Link></li>
       
          <li><Link to="/Enq" className="hover:text-gray-300">Enquirey</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
